<template>
  <div class="human-capitalt-view-past">
    <h2 class="heading-lv2">{{this.childcareRate.year}}年{{this.month}}月期</h2>
    <div class="human-capitalt-data-wrap">
      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">育児休業取得者数</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col style="width: 42%;">
            <col style="width: 42%;">
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>取得者</th>
              <th>対象者</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="childcareRate.maleAcquisitionCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="childcareRate.maleTargetCount" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="childcareRate.femaleAcquisitionCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="childcareRate.femaleTargetCount" :unit="this.unit"/></span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>合計</th>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfAcquisitionCount" :unit="this.unit"/></span>
              </td>
              <td>
                <span class="human-capitalt-data-table__text"><Currency :value="this.sumOfTargetCount" :unit="this.unit"/></span>
              </td>
            </tr>
          </tbody>
        </table>
      </div><!--/human-capitalt-data-wrap__table01-->

      <div class="human-capitalt-data-wrap__arrow"></div>

      <div class="human-capitalt-data-wrap__table01">
        <p class="l-formGroup__label u-mb10">育児休業取得率</p>
        <table class="human-capitalt-data-table">
          <colgroup>
            <col style="width: 16%;">
            <col>
          </colgroup>
          <thead>
            <tr>
              <th></th>
              <th>取得率</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <th>男性</th>
              <td>
                <span class="human-capitalt-data-table__text">
                  <strong><Currency :value="this.calcAchievementMaleChildcareRate" :unit="this.unit2"/></strong>
                </span>
              </td>
            </tr>
            <tr>
              <th>女性</th>
              <td>
                <span class="human-capitalt-data-table__text">
                  <strong><Currency :value="this.calcAchievementFemaleChildcareRate" :unit="this.unit2"/></strong>
                </span>
              </td>
            </tr>
            <tr class="human-capitalt-data-table__bordertop">
              <th>全社</th>
              <td>
                <span class="human-capitalt-data-table__text">
                  <strong><Currency :value="this.calcAchievementAllChildcareRate" :unit="this.unit2"/></strong>
                </span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

    </div><!--/human-capitalt-data-wrap-->
    <div class="l-contentsGrid2 u-mt30">
      <div class="l-contentsGrid2__item">
        <div>
          <div class="l-formGroup">
            <label class="l-formGroup__label u-mb10">実績に関するメモ</label>
              <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(childcareRate.resultMemo)"></p>
          </div>
        </div>
      </div>
      <div class="l-contentsGrid2__item">
        <div class="l-contentsMemo">
          <div class="l-formGroup">
            <div class="l-contentsMemo__title">
              <label class="l-formGroup__label">具体的なアクション</label>
            </div>
            <div class="l-contentsMemo__body">
                <div>
                  <p  class="l-text" style="white-space: pre-line;" v-html="repalceLink(childcareRate.actionMemo)"></p>
                </div>
            </div>
          </div>
        </div>
      </div>
    </div><!--/l-contentsGrid2 u-mt30-->
  </div><!--/human-capitalt-data-past-->

</template>

<script>
import Currency from '@/components/parts/human_capital/parts/Currency.vue';

export default {
  components: {
    Currency,
  },
  props: {
    // 表示年度の育児休業取得率データ
    childcareRate: {},
    month: null,
    num: null,
  },
  data() {
    return {
      unit: '名',
      unit2:'％',
    }
  },
  computed: {
    sumOfAcquisitionCount() {
      if ( !(this.childcareRate.maleAcquisitionCount!=null && this.childcareRate.femaleAcquisitionCount!=null) ) {
        return null;
      }else if ( String(this.childcareRate.maleAcquisitionCount).length * String(this.childcareRate.femaleAcquisitionCount).length == 0) {
        return null;
      }else if ( isNaN(this.childcareRate.maleAcquisitionCount) || isNaN(this.childcareRate.femaleAcquisitionCount)) {
        return null;
      }else{
        return Number(this.childcareRate.maleAcquisitionCount) + Number(this.childcareRate.femaleAcquisitionCount);
      }
    },
    sumOfTargetCount() {
      if ( !(this.childcareRate.maleTargetCount!=null && this.childcareRate.femaleTargetCount!=null) ) {
        return null;
      }else if ( String(this.childcareRate.maleTargetCount).length * String(this.childcareRate.femaleTargetCount).length == 0) {
        return null;
      }else if ( isNaN(this.childcareRate.maleTargetCount) || isNaN(this.childcareRate.femaleTargetCount)) {
        return null;
      }else{
        return Number(this.childcareRate.maleTargetCount) + Number(this.childcareRate.femaleTargetCount);
      }
    },
    calcAchievementMaleChildcareRate() {
      if ( !(this.childcareRate.maleAcquisitionCount!=null && this.childcareRate.maleTargetCount!=null) ) {
        return null;
      }else if ( String(this.childcareRate.maleAcquisitionCount).length * String(this.childcareRate.maleTargetCount).length == 0) {
        return null;
      }else if ( isNaN(this.childcareRate.maleAcquisitionCount) || isNaN(this.childcareRate.maleTargetCount)) {
        return null;
      }else{
        if ( this.childcareRate.maleTargetCount == 0 ) return null;
        if ( this.childcareRate.maleAcquisitionCount == 0 ) return 0;
        let val = (this.childcareRate.maleAcquisitionCount / this.childcareRate.maleTargetCount) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    calcAchievementFemaleChildcareRate() {
      if ( !(this.childcareRate.femaleAcquisitionCount!=null && this.childcareRate.femaleTargetCount!=null) ) {
        return null;
      }else if ( String(this.childcareRate.femaleAcquisitionCount).length * String(this.childcareRate.femaleTargetCount).length == 0) {
        return null;
      }else if ( isNaN(this.childcareRate.femaleAcquisitionCount) || isNaN(this.childcareRate.femaleTargetCount)) {
        return null;
      }else{
        if ( this.childcareRate.femaleTargetCount == 0 ) return null;
        if ( this.childcareRate.femaleAcquisitionCount == 0 ) return 0;
        let val = (this.childcareRate.femaleAcquisitionCount / this.childcareRate.femaleTargetCount) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }
    },
    calcAchievementAllChildcareRate() {
      if ( this.sumOfAcquisitionCount != null && this.sumOfTargetCount != null ){
        if ( this.sumOfTargetCount == 0 ) return null;
        if ( this.sumOfAcquisitionCount == 0 ) return 0;
        let val = (this.sumOfAcquisitionCount / this.sumOfTargetCount) * 100 * 10; // 小数点以下１まで表示なので10
        return Math.round(val)/10;
      }else{
        return null;
      }
    },
  },
  watch: {
    childcareRate() {
      this.inputChildcareRate();
    },
  },
  created: function () {

  },
  mounted() {

  },
  methods: {
    inputChildcareRate() {
      this.$emit("change-childcare-rate-detail", {
        childcareRate: this.childcareRate,
        month: this.month,
        num: this.num,
      });
    },
    repalceLink(text) {
      return text ? text.replace(/(https?:\/\/[^\s]*)/g, "<a href='$1'style='text-decoration: underline; color: #0070be;' target='_blank' rel='noopener noreferrer'>$1</a>") : '';
    },

  }
}

</script>
